document.addEventListener('DOMContentLoaded', () => {
  const storageKey = 'threePreferredSize';
  const normalize = (value) => String(value || '').trim().toUpperCase();
  const readStoredSize = () => {
    try {
      return normalize(sessionStorage.getItem(storageKey));
    } catch (error) {
      return '';
    }
  };
  const storeSize = (value) => {
    try {
      if (value) sessionStorage.setItem(storageKey, normalize(value));
      else sessionStorage.removeItem(storageKey);
    } catch (error) {
      // The selector still works if browser storage is unavailable.
    }
  };
  const requestedSize = normalize(new URLSearchParams(window.location.search).get('size'));
  const preferredSize = requestedSize || readStoredSize();

  document.querySelectorAll('[data-home-size-filter]').forEach((root) => {
    const buttons = [...root.querySelectorAll('[data-home-size]')];
    const cards = [...root.querySelectorAll('[data-home-product]')];
    const label = root.querySelector('[data-home-size-label]');
    const empty = root.querySelector('[data-home-size-empty]');
    const collectionLink = root.querySelector('[data-size-collection-link]');
    const limit = Number(root.dataset.homeLimit) || 8;
    let selectedSize = preferredSize;

    const render = () => {
      let visible = 0;
      cards.forEach((card) => {
        const sizes = (card.dataset.sizes || '').split('|').map(normalize).filter(Boolean);
        const matches = !selectedSize || sizes.includes(selectedSize);
        const show = matches && visible < limit;
        card.hidden = !show;
        if (show) visible += 1;
      });

      buttons.forEach((button) => {
        const active = normalize(button.dataset.homeSize) === selectedSize;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      if (label) label.textContent = selectedSize || 'TUTTE LE TAGLIE';
      if (empty) empty.hidden = visible !== 0;
      if (collectionLink) {
        const baseHref = collectionLink.dataset.baseHref || collectionLink.getAttribute('href');
        collectionLink.href = selectedSize ? baseHref + '?size=' + encodeURIComponent(selectedSize) : baseHref;
      }
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const nextSize = normalize(button.dataset.homeSize);
        selectedSize = selectedSize === nextSize ? '' : nextSize;
        storeSize(selectedSize);
        render();
      });
    });
    root.querySelector('[data-home-size-reset]')?.addEventListener('click', () => {
      selectedSize = '';
      storeSize('');
      render();
    });
    render();
  });

  const nativeForm = document.querySelector('[data-native-size-filter]');
  const nativeInputs = nativeForm
    ? [...nativeForm.querySelectorAll('input[type="checkbox"]')]
    : [];

  if (nativeInputs.length) {
    const checkedInputs = nativeInputs.filter((input) => input.checked);
    if (checkedInputs.length) {
      storeSize(checkedInputs[0].value);
    } else if (preferredSize) {
      const matchingInput = nativeInputs.find((input) => normalize(input.value) === preferredSize);
      if (matchingInput && !matchingInput.disabled) {
        matchingInput.checked = true;
        nativeForm.submit();
        return;
      }
    }

    nativeInputs.forEach((input) => {
      input.addEventListener('change', () => {
        const active = nativeInputs.find((candidate) => candidate.checked);
        storeSize(active ? active.value : '');
        nativeForm.submit();
      });
    });
  } else {
    const buttons = [...document.querySelectorAll('[data-local-size]')];
    const getCards = () => [...document.querySelectorAll('[data-local-product]')];
    const count = document.querySelector('[data-visible-count]');
    const selected = new Set(preferredSize ? [preferredSize] : []);

    const filterCards = () => {
      let visible = 0;
      getCards().forEach((card) => {
        const sizes = (card.dataset.sizes || '').split('|').map(normalize).filter(Boolean);
        const show = !selected.size || [...selected].some((size) => sizes.includes(size));
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (count) count.textContent = visible;
      buttons.forEach((button) => {
        button.classList.toggle('is-active', selected.has(normalize(button.dataset.localSize)));
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const size = normalize(button.dataset.localSize);
        if (selected.has(size)) selected.delete(size);
        else selected.add(size);
        storeSize(selected.size ? [...selected][0] : '');
        filterCards();
      });
    });
    document.addEventListener('three:products-appended', filterCards);
    filterCards();
  }

  document.querySelectorAll('[data-size-reset]').forEach((reset) => {
    reset.addEventListener('click', () => storeSize(''));
  });

  const collectionGrid = document.querySelector('[data-collection-grid]');
  const loadMoreWrap = document.querySelector('[data-load-more-wrap]');
  const loadMoreButton = loadMoreWrap?.querySelector('[data-load-more]');
  const loadMoreStatus = loadMoreWrap?.querySelector('[data-load-more-status]');

  if (collectionGrid && loadMoreWrap && loadMoreButton) {
    const mergeCurrentParameters = (href) => {
      const nextUrl = new URL(href, window.location.href);
      const currentUrl = new URL(window.location.href);

      currentUrl.searchParams.forEach((value, key) => {
        if (key !== 'page' && !nextUrl.searchParams.has(key)) {
          nextUrl.searchParams.append(key, value);
        }
      });

      return nextUrl.toString();
    };

    let loading = false;

    loadMoreButton.addEventListener('click', async (event) => {
      event.preventDefault();
      if (loading) return;

      loading = true;
      loadMoreButton.classList.add('is-loading');
      loadMoreButton.setAttribute('aria-busy', 'true');
      if (loadMoreStatus) loadMoreStatus.textContent = 'Caricamento dei prodotti in corso…';

      try {
        const response = await fetch(mergeCurrentParameters(loadMoreButton.href), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) throw new Error('Unable to load the next collection page.');

        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = documentFragment.querySelector('[data-collection-grid]');
        const nextButton = documentFragment.querySelector('[data-load-more]');

        if (!nextGrid) throw new Error('The next product grid is missing.');

        const newProducts = [...nextGrid.children];
        newProducts.forEach((product) => product.classList.add('is-load-more-item'));
        collectionGrid.append(...newProducts);

        requestAnimationFrame(() => {
          newProducts.forEach((product) => product.classList.add('is-visible'));
        });

        document.dispatchEvent(new CustomEvent('three:products-appended', {
          detail: { products: newProducts }
        }));

        if (nextButton?.href) {
          loadMoreButton.href = mergeCurrentParameters(nextButton.href);
          loadMoreButton.classList.remove('is-loading');
          loadMoreButton.removeAttribute('aria-busy');
          if (loadMoreStatus) loadMoreStatus.textContent = `${newProducts.length} prodotti aggiunti.`;
          loading = false;
        } else {
          if (loadMoreStatus) loadMoreStatus.textContent = 'Hai visualizzato tutti i prodotti.';
          loadMoreWrap.classList.add('is-complete');
          window.setTimeout(() => loadMoreWrap.remove(), 900);
        }
      } catch (error) {
        loadMoreButton.classList.remove('is-loading');
        loadMoreButton.removeAttribute('aria-busy');
        if (loadMoreStatus) loadMoreStatus.textContent = 'Non è stato possibile caricare altri prodotti. Riprova.';
        loading = false;
      }
    });
  }
});
